import { handleActions } from 'redux-actions';
import { List } from 'immutable';
import { entityStateFactory } from 'web-app/react/entities/factory/reducer-factory';
import { checkInChildSuccess } from 'signin-app/child/check-in/actions';
import { checkOutChildSuccess } from 'signin-app/child/check-out/actions';
const EntityStateFactory = entityStateFactory();
const initialState = new EntityStateFactory();
const updateChildEntityMap = (state, payload, childId, checkedIn) => {
    const child = state.entityMap.get(childId);
    if (!child) {
        return state;
    }
    const childWithUpdatedCheckins = child.update('checkins', checkins => List([payload.response, ...checkins]));
    const updatedChild = childWithUpdatedCheckins.merge({
        checkedIn,
        ...payload.response,
        groupId: child.groupId,
        lastCheckIn: payload.response,
        pickupName: payload.pickupName,
    });
    const updatedEntityMap = state.entityMap.merge({ [updatedChild.id]: updatedChild });
    return state.merge({
        entityMap: updatedEntityMap,
    });
};
export default handleActions({
    [checkInChildSuccess.type]: (state, { payload }) => {
        if (!payload) {
            return state;
        }
        return updateChildEntityMap(state, payload, payload.response.childId, true);
    },
    [checkOutChildSuccess.type]: (state, { payload }) => {
        if (!payload) {
            return state;
        }
        return updateChildEntityMap(state, payload, payload.response.childId, false);
    },
}, initialState);
